$(document).on('hide.bs.collapse', '.collapse', function (e) {
    var sibling = $(e.target.previousElementSibling);

    if (sibling.hasClass('dnJs-collapseNext')) {
        sibling.removeClass('dnJs-collapseNext-active');
    }
});

$(document).on('show.bs.collapse', '.collapse', function (e) {
    var sibling = $(e.target.previousElementSibling);

    if (sibling.hasClass('dnJs-collapseNext')) {
        sibling.addClass('dnJs-collapseNext-active');
    }
});

$(document).on('click', '.dnJs-collapseNext', function (e) {
    e.preventDefault();
    var collapse = $(this).next('.collapse');
    collapse.collapse('toggle');
});